<template>
  <div v-if="selectedMirror && selectedMirror.length" class="mirror-content">
    <div
      v-if="!$vuetify.breakpoint.xsAndDown"
      class="actions-top d-flex justify-end mt-3"
    >
      <slot name="actions-top" />
      <!-- schedule focus -->
      <v-btn
        v-if="!hideActionScheduleFocus"
        icon
        @click="$emit('schedule-focus')"
      >
        <v-icon>schedule</v-icon>
      </v-btn>
      <!-- focus -->
      <v-btn
        icon
        v-if="!hideActionFocus"
        @click="$emit('focus')"
        :class="{ disabled: disableFocusButton }"
      >
        <v-icon>center_focus_weak</v-icon>
      </v-btn>
      <!-- Refresh -->
      <v-btn icon @click="$emit('refresh')">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-spacer />
      <!-- Drawer  button -->
      <v-btn icon @click="$emit('drawer-click')">
        <v-icon color="primary">menu_open</v-icon>
      </v-btn>
    </div>

    <div class="header-info">
      <div class="header-info__program">
        <v-icon>tv</v-icon>{{ currentProgramName }}
      </div>

      <div class="header-info__date">
        <v-icon>today</v-icon>{{ displayToday }}
      </div>
    </div>

    <MirrorFilters
      :studioEnabled="hasItemFromType(categories.studio.type)"
      :vtEnabled="hasItemFromType(categories.vt.type)"
      :liveEnabled="hasItemFromType(categories.live.type)"
      :screenEnabled="hasItemFromType(categories.screen.type)"
      :othersEnabled="hasItemFromType(categories.others.type)"
    />

    <div class="mirrors">
      <MirrorCard
        v-for="(slug, index) in filteredMirror"
        :id="`card-${index}`"
        :reference="`mirror-${slug.id}`"
        :key="index"
        :activity="slug"
        lastMirrorAcessed="lastMirrorAcessed"
        :activityType="normalizeType(slug.item_type)"
        :class="{
          'mirror-card-selected': selectedSlugId === slug.id,
        }"
        @openMirrorItemDetails="$emit('openMirrorItemDetails', $event)"
      />
    </div>
  </div>
  <Error
    v-else
    :textTitle="'Tão <span>vazio</span> por aqui...'"
    :textDescription="'Não encontramos nenhuma retranca neste espelho.'"
    :imageTitle="'hungry'"
    class="no-activities inside"
  />
</template>

<script>
import { mapState } from 'vuex';
import MirrorCard from '@/components/mirrors/MirrorCard.vue';
import MirrorFilters from '@/components/mirrors/MirrorFilters.vue';
import Error from '@/components/shared/Error.vue';
import { categories, normalizeType } from '@/utils/mirrorFormatter.js';
import { weekdayWithDate, weekdayWithSpecificDate } from '@/utils/date.js';

export default {
  name: 'MirrorSidebar',
  components: {
    MirrorFilters,
    MirrorCard,
    Error,
  },
  props: {
    selectedSlugId: String,
    disableFocusButton: {
      type: Boolean,
      default: true,
    },
    filteredMirror: {
      type: Array,
      required: true,
    },
    selectedMirror: {
      type: Array,
      default: () => [],
    },
    processingDate: {
      type: String,
      required: false,
    },
    hideActionScheduleFocus: {
      type: Boolean,
      default: false,
    },

    hideActionFocus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categories,
      autoScrollOptions: {
        duration: 800,
        offset: 120,
        // container se refere ao elemento que contem o scroll
        container: this.$vuetify.breakpoint.mdAndDown
          ? 'html'
          : '.v-navigation-drawer__content',
      },
    };
  },
  computed: {
    ...mapState({
      reporterAutoScrollTarget: state => state.mirror.reporterAutoScrollTarget,
      timeAutoScrollTarget: state => state.mirror.timeAutoScrollTarget,
    }),
    displayToday() {
      return this.processingDate
        ? weekdayWithSpecificDate(this.processingDate)
        : weekdayWithDate();
    },
    currentProgramTag() {
      return this.$route.params.short_name;
    },
    currentProgramName() {
      return this.selectedMirror && this.selectedMirror.length
        ? this.selectedMirror[0].program_name
        : '-';
    },
  },
  methods: {
    weekdayWithDate,
    normalizeType,
    hasItemFromType(type) {
      return !!this.selectedMirror.find(item => {
        return this.normalizeType(item.item_type) === type;
      });
    },
  },
  watch: {
    reporterAutoScrollTarget() {
      if (this.reporterAutoScrollTarget) {
        this.$vuetify.goTo(
          `#card-${this.reporterAutoScrollTarget}`,
          this.autoScrollOptions,
        );
        this.$store.dispatch('mirror/resetAutoScrollTarget');
      }
    },
    timeAutoScrollTarget() {
      if (this.timeAutoScrollTarget) {
        this.$vuetify.goTo(
          `#card-${this.timeAutoScrollTarget}`,
          this.autoScrollOptions,
        );
        this.$store.dispatch('mirror/resetAutoScrollTarget');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/buttons.scss';

.mirror-content {
  display: block;
  width: 100%;
  background-color: $color-white;
  padding: 0 10px;
  z-index: 8;

  .actions-top {
    background: $color-white;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  .header-info,
  .mirrors {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .header-info {
    width: 100%;
    height: 56px;
    padding: 16px 24px;
    font-size: 0.76em;
    font-family: 'globotipo' !important;
    font-weight: 600 !important;
    color: $color-black-64;
    text-transform: uppercase;
    background-color: $color-white;

    i {
      font-size: 1.4em;
      margin: 0 8px 0 0;
      color: $color-black-24;
    }
  }

  .mirrors {
    margin: 0;
    padding: 10px 16px 88px;
    background-color: $color-white;
  }

  .mirror-card-selected {
    background-color: #07070711;
  }
}
</style>
